import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import mobxState from '@src/store/index';
import './style.less';

const LINK_MAP = [
  {
    icon: require('./imgs/dashbord.png'),
    iconCur: require('./imgs/dashbord-cur.png'),
    name: '首页',
    link: '/monitor/dashboard'
  },
  {
    icon: require('./imgs/desktop.png'),
    iconCur: require('./imgs/desktop-cur.png'),
    name: '实况',
    link: '/monitor/curdesktop',
    isPersonHidden: true
  },
  {
    icon: require('./imgs/shot.png'),
    iconCur: require('./imgs/shot-cur.png'),
    name: '截屏',
    link: '/monitor/screenshot'
  },
  {
    icon: require('./imgs/report.png'),
    iconCur: require('./imgs/report-cur.png'),
    name: '报告',
    link: '/monitor/report',
    isPersonHidden: true
  }
];

// props: RouteComponentProps,
export default observer(({ children }: any) => {
  const { curUserInfo } = mobxState.monitor.user;
  const pathname = window.location.pathname;
  let history = useHistory();

  useEffect(() => {
    if (history.location.pathname === '/monitor') {
      history.push('/monitor/dashboard');
    }
  }, []);

  const menuArr = useMemo(() => {
    if (!curUserInfo) return [];
    return curUserInfo.permission === 'self' ? LINK_MAP.filter(val => !val.isPersonHidden) : LINK_MAP;
  }, [curUserInfo]);

  // 未登录或（设置仅主管可见snapshot_scope === 2后，普通成员）无菜单
  if (!curUserInfo || (curUserInfo.permission === 'self' && curUserInfo.snapshot_scope === 2))
    return (
      <div className="LayoutMonitor">
        <div className="LayoutMonitor-content">{children}</div>
      </div>
    );

  return (
    <div className="LayoutMonitor">
      <div className="LayoutMonitor-content">{children}</div>
      <div className="LayoutMonitor-footer">
        {menuArr.map(item => (
          <Link className={`item ${pathname === item.link ? 'cur' : ''}`} to={item.link} key={item.link}>
            <img className="LayoutMonitor-footerIcon" src={pathname === item.link ? item.iconCur : item.icon} />
            <div className="LayoutMonitor-footertxt">{item.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
});
